import { Controller } from "@hotwired/stimulus"

// Click-the-pill-to-edit interaction for the Notices status column.
//
// Resting state: a colored .sp-status.sp-pill button showing the current
// label (Printed / Packaged / In Transit / Delivered). On click we hide the
// pill and reveal a co-located <select> with the same options. When the user
// picks a new value we:
//   1. update the pill's color + label,
//   2. submit the form the select belongs to (via its `form` attribute, since
//      the form lives outside the <table>; remote: true handles persistence),
//   3. swap back to the pill.
// On a plain blur (no change) we just snap back to the pill - no save.
//
// The controller is UI-only - it never invents new save logic. Persistence
// stays on the existing simple_form_for(djob, remote: true).
export default class extends Controller {
  static targets = ["pill", "select"]
  static values = {
    status: String,
    classes: Object, // { printed: "neutral", packaged: "warn", ... }
    labels: Object   // { printed: "Printed", in_transit: "In Transit", ... }
  }

  showSelect(event) {
    event.preventDefault()
    this.pillTarget.hidden = true
    this.selectTarget.hidden = false
    // Defer focus so the click that triggered showSelect doesn't immediately
    // count as a blur on the freshly-revealed select.
    requestAnimationFrame(() => this.selectTarget.focus())
  }

  commit(event) {
    const newValue = this.selectTarget.value
    if (newValue !== this.statusValue) {
      this.statusValue = newValue
      this.refreshPill(newValue)
      const form = this.selectTarget.form
      if (form) {
        if (typeof form.requestSubmit === "function") {
          form.requestSubmit()
        } else {
          form.submit()
        }
      }
    }
    this.selectTarget.hidden = true
    this.pillTarget.hidden = false
  }

  refreshPill(value) {
    const modifier = (this.classesValue && this.classesValue[value]) || "neutral"
    const label    = (this.labelsValue  && this.labelsValue[value])  || value

    // Swap any sp-pill--* modifier for the one matching the new value.
    const stale = Array.from(this.pillTarget.classList).filter(c => c.startsWith("sp-pill--"))
    stale.forEach(c => this.pillTarget.classList.remove(c))
    this.pillTarget.classList.add(`sp-pill--${modifier}`)

    this.pillTarget.textContent = label
    this.pillTarget.dataset.status = value
  }
}
